import React from 'react';
import type { OptionProps, SingleValueProps } from 'react-select';
import { components } from 'react-select';
import * as styles from './ProvisionSelectOption.module.scss';
import Badge from '../../components/Badge';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { ProvisionType } from '../../graphql/generated/graphql';
import { userBadgeColors } from '../../user/profile/UserBadge';

gql(`
  fragment ProvisionSelectValue_provision on Provision {
    id
    name
    type
  }
`);

type ProvisionOption = { value: string; label: string; type: ProvisionType };

type ProvisionSelectValuesProps = {
  data: ProvisionOption;
};

const ProvisionSelectValue = ({
  data: { label, type },
}: ProvisionSelectValuesProps) => (
  <div className={styles.option}>
    {label}
    {type !== 'USER' && (
      <div className={styles.badge}>
        <Badge color={userBadgeColors[type]}>{type}</Badge>
      </div>
    )}
  </div>
);

const PROVISIONS_TO_OPTIONS_PROVISION_FRAGMENT = gql(`
  fragment provisionsToOptions_provision on Provision {
    ...ProvisionSelectValue_provision
  }
`);

export const provisionsToOptions = (
  provisions: DocumentType<typeof PROVISIONS_TO_OPTIONS_PROVISION_FRAGMENT>[],
): ProvisionOption[] =>
  provisions.map((p) => ({
    label: p.name,
    value: p.id,
    type: p.type,
  }));

type ProvisionSelectOptionProps = OptionProps<ProvisionOption, false>;

gql(`
  fragment ProvisionSelectOption_provision on Provision {
    ...ProvisionSelectValue_provision
  }
`);

export const ProvisionSelectOption = (props: ProvisionSelectOptionProps) => (
  <components.Option {...props}>
    <ProvisionSelectValue {...props} />
  </components.Option>
);

gql(`
  fragment ProvisionSelectSingleValue_provision on Provision {
    ...ProvisionSelectValue_provision
  }
`);

type ProvisionSelectSingleValueProps = SingleValueProps<ProvisionOption>;

export const ProvisionSelectSingleValue = (
  props: ProvisionSelectSingleValueProps,
) => (
  <components.SingleValue {...props}>
    <ProvisionSelectValue {...props} />
  </components.SingleValue>
);
